export const HeaderTabelExchangeRate = [
  'Effective Date',
  'Currency',
  'Amount',
  'Action',
];
